var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "@/components/modalv2.vue";
import WovenStrip from "@/components/wovenstrip.vue";
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styleClass = "display: block";
        return _this;
    }
    Account.prototype.toggleModal = function () {
        this.toggle();
        this.showModal = !this.showModal;
        this.styleClass =
            this.styleClass === "display: block"
                ? "display: none !important"
                : "display: block";
    };
    __decorate([
        Prop()
    ], Account.prototype, "toggle", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "loading", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "classes", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "useRedHeaderClose", void 0);
    Account = __decorate([
        Component({
            name: "ExtendModal",
            components: { WovenStrip: WovenStrip, Modal: Modal },
        })
    ], Account);
    return Account;
}(Vue));
export default Account;
